module.exports = __webpack_public_path__ + "static/img/missedPenalty.0d121d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/missedPenalty.svg
// module id = PoTn
// module chunks = 94